import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { HashRouter } from 'react-router-dom'
import configureStore from './store/configureStore'
import './assets/css/normalize.css'
import './assets/css/fonts.css'
import './assets/css/icons.css'
import './assets/css/globals.css'

import App from './App'
import registerServiceWorker from './registerServiceWorker'

import 'core-js/fn/array/find'
import 'core-js/fn/object/entries'
import 'core-js/fn/array/from'
// import 'core-js/fn/array/includes'
// import 'core-js/fn/number/is-nan'

const store = configureStore()

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <App />
    </HashRouter>
  </Provider>,
  document.getElementById('schiphol-app'))

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js